import proxybase from './proxybase';

class crecerForms {
  saveSurveyAnswers(body) {
    return proxybase
      .post(`/crecer/saveSurveyAnswers`, body)
      .then((response) => {
        return Promise.resolve(response);
      })
      .catch((error) => {
        return Promise.reject(error);
      });
  }
  getSurveyAnswers(body) {
    return proxybase
      .post(`/crecer/getSurveyAnswers`, body)
      .then((response) => {
        return Promise.resolve(response);
      })
      .catch((error) => {
        return Promise.reject(error);
      });
  }
  saveRelationsForm(body) {
    return proxybase
      .post(`/crecer/saveRelationsForm`, body)
      .then((response) => {
        return Promise.resolve(response);
      })
      .catch((error) => {
        return Promise.reject(error);
      });
  }
  updateRelationsForm(body) {
    return proxybase
      .post(`/crecer/updateRelationsForm`, body)
      .then((response) => {
        return Promise.resolve(response);
      })
      .catch((error) => {
        return Promise.reject(error);
      });
  }
  toggleRelationsWaitlist(body) {
    return proxybase
      .post(`/crecer/toggleRelationsWaitlist`, body)
      .then((response) => {
        return Promise.resolve(response);
      })
      .catch((error) => {
        return Promise.reject(error);
      });
  }
  checkInRelationInscription(body) {
    return proxybase
      .post(`/crecer/checkInRelationInscription`, body)
      .then((response) => {
        return Promise.resolve(response);
      })
      .catch((error) => {
        return Promise.reject(error);
      });
  }
  getAllRelationsForm(body) {
    return proxybase
      .post(`/crecer/getAllRelationsForm`, body)
      .then((response) => {
        return Promise.resolve(response);
      })
      .catch((error) => {
        return Promise.reject(error);
      });
  }
  getTotalsCrecerAttendanceByDay(body) {
    return proxybase
      .post(`/crecer/getTotalsCrecerAttendanceByDay`, body)
      .then((response) => {
        return Promise.resolve(response);
      })
      .catch((error) => {
        return Promise.reject(error);
      });
  }
  getGuestSelfAttendanceQRUrl(body) {
    return proxybase
      .post(`/crecer/getGuestSelfAttendanceQRUrl`, body)
      .then((response) => {
        return Promise.resolve(response);
      })
      .catch((error) => {
        return Promise.reject(error);
      });
  }
  getHistoricalQR(body = {}) {
    return proxybase
      .post(`/crecer/getHistoricalQR`, body)
      .then((response) => {
        return Promise.resolve(response);
      })
      .catch((error) => {
        return Promise.reject(error);
      });
  }
  getSelfAttendanceByToken(body) {
    return proxybase
      .post(`/crecer/getSelfAttendanceByToken`, body)
      .then((response) => Promise.resolve(response))
      .catch((error) => Promise.reject(error));
  }
  getSelfAttendanceGuestPreview(body) {
    return proxybase
      .post(`/crecer/getSelfAttendanceGuestPreview`, body)
      .then((response) => Promise.resolve(response))
      .catch((error) => Promise.reject(error));
  }
  submitSelfAttendanceConfirmation(body) {
    return proxybase
      .post(`/crecer/submitSelfAttendanceConfirmation`, body)
      .then((response) => Promise.resolve(response))
      .catch((error) => Promise.reject(error));
  }
  markSelfAttendance(body) {
    return proxybase
      .post(`/crecer/markSelfAttendance`, body)
      .then((response) => Promise.resolve(response))
      .catch((error) => Promise.reject(error));
  }
}
const crecerFormsInstance = new crecerForms();
export default crecerFormsInstance;
